<div class="date-input">
  <form class="g-3" [formGroup]="inputForm">
    <ng-container formGroupName="date">
      <input type="tel"
             formControlName="day"
             class="form-control"
             placeholder="DD"
             min="1"
             max="31"
             maxlength="2"
             yp-e2e-id="day"
             [value]="day?.value"/>
      <input type="tel"
             #monthElement
             formControlName="month"
             class="form-control"
             placeholder="MM"
             min="1"
             max="12"
             maxlength="2"
             yp-e2e-id="month"
             [value]="month?.value"/>
      <input type="tel"
             #yearElement
             formControlName="year"
             class="form-control"
             placeholder="YYYY"
             min="1900"
             max="2100"
             minlength="4"
             maxlength="4"
             yp-e2e-id="year"
             [value]="year?.value"/>
    </ng-container>
  </form>
</div>

<div class="alert-container mt-2" *ngIf="(day?.errors && day?.touched) || (month?.errors && month?.touched) || (year?.errors && year?.touched)">
  <div class="alert alert-danger">Please Enter valid date</div>
</div>
